module.exports = __webpack_public_path__ + "static/media/hoadon.22ae9f56.svg";